import Config from "../lib/config";
import CryptoJS from 'crypto-js';
import axios from 'axios'

export const isEmpty = value =>
  value === undefined ||
  value === null ||
  (typeof value === 'object' && Object.keys(value).length === 0) ||
  (typeof value === 'string' && value.trim().length === 0) ||
  (typeof value === 'string' && Number(value) === 0) ||
  (typeof value === 'number' && Number(value) === 0);

export const NumberOnly = (data) => {
  return data.toString().replace(Config.NumberOnly, "");
};

export const address_showing = (item) => {
  if (item && item.toString().length > 10) {
    var slice_front = item.slice(0, 9)
    var slice_end = item.slice(item.length - 9, item.length - 1)
    return slice_front + '....' + slice_end
  }
  else return item
}

// Common Formdata function
export const AppenData = (data) => {
  var formdata = new FormData()
  var SendDta = Object.entries(data).map((item) => {
    if (Array.isArray(item[1])) {
      var come = item[1].map((data) => {
        if (data?.type && data?.size) {
          //file
          formdata.append(item[0], data)
        }
        else {
          formdata.append(item[0], EncryptData(data))

        }
        return formdata
      })
      return come

    }
    else {
      if (item[1]?.type && item[1]?.size) {
        //file type
        formdata.append(item[0], item[1])
      }
      else {
        formdata.append(item[0], EncryptData(item[1]))

      }
      return formdata
    }
  })
  return [formdata]
}

export const axiosFunc = async (data, reqData, formData) => {
  try {
    const reqURL = data?.url
    if (reqData) {
      if (formData) {
        data.data = AppenData(reqData)[0]
      } else {
        if (data?.method?.toLowerCase() === "get") {
          data.params = { data: EncryptData(reqData) }
        } else {
          data.data = { data: EncryptData(reqData) }
        }
      }
    }

    if (!isEmpty(localGet("token")) && !data.headers) {
      data.headers = { ...(data?.headers || {}), Authorization: `Bearer ${localGet("token")}` }
      axios.defaults.headers.common.Authorization = `Bearer ${localGet("token")}`
    }

    let Resp = await axios(data)


    if (Resp?.data) {
      Resp.data = Resp.data ? isEmpty(Decryptdata(Resp.data)) ? Resp.data : Decryptdata(Resp.data) : Resp.data
    }
    return Resp.data
  } catch (error) {
    // console.log("erro on axiosFunc", error);
    return { status: false, success: "error", msg: `error on axios ${data?.url}` }
  }


}


export const EncryptData = (data, key) => {
  try {
    if (key) {
      return CryptoJS.AES.encrypt(data, Config.KEY).toString()
    } else {
      const encJson = CryptoJS.AES.encrypt(JSON.stringify(data), Config.KEY).toString();
      const encData = CryptoJS.enc.Base64.stringify(
        CryptoJS.enc.Utf8.parse(encJson)
      );
      return encData;
    }

  }
  catch (err) {
    // console.log("encerr", err);
    return false
  }
}


export const Decryptdata = ((data, key) => {
  try {
    if (key) {
      return CryptoJS.AES.decrypt(data, Config.KEY).toString(CryptoJS.enc.Utf8)
    }
    else {
      const decData = CryptoJS.enc.Base64.parse(data)?.toString(CryptoJS.enc.Utf8);
      const bytes = CryptoJS.AES.decrypt(decData, Config.KEY).toString(CryptoJS.enc.Utf8);
      return JSON.parse(bytes)
    }
  } catch (error) {
    // console.log(" erro on Decryptdata", error);
    return ""
  }


})

export const videoFileFormats = [
  'mp4',
  'avi',
  'mkv',
  'mov',
  'wmv',
  'flv',
  'webm',
  'm4v',
  '3gp',
  'mpeg',
  'ogv',
  'mpg',
  'asf',
  'rm',
  'swf',
];

export const imgFormats = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "webp",
  "svg",
  "bmp",
  "tiff",
  "ico",
  "heif",
  "heic",
  "jfif"
];


export function calculateStakingDaysPassed(eventStartDate, eventEndDate, stakingStartDate, stakingEndDate) {
  // Parse the input strings to Date objects
  const eventStart = new Date(eventStartDate);
  const eventEnd = new Date(eventEndDate);
  const stakingStart = new Date(stakingStartDate);
  const stakingEnd = new Date(stakingEndDate);

  // Get the current date
  const currentDate = new Date();

  // Determine the overlap end date (min of event end date, staking end date, and today's date)
  const overlapEnd = new Date(Math.min(eventEnd, stakingEnd, currentDate));

  // If the overlap end date is before the staking start date or event start date, there is no overlap
  if (overlapEnd < stakingStart || overlapEnd < eventStart) {
    return 0;
  }

  // Calculate the number of days within the overlap
  const timeDiff = overlapEnd - Math.max(stakingStart, eventStart);
  const daysOfStaking = Math.floor(timeDiff / (1000 * 60 * 60 * 24)) + 1;

  return daysOfStaking;
}


export const getDaysOfDesiredMonth = (Season) => {

  var month;

  if (Season == "Season 1") month = 3; // next march last date
  else if (Season == "Season 2") month = 6; // next may last date
  else if (Season == "Season 3") month = 9; // next june last date
  else if (Season == "Season 4") month = 12; // next oct last date

  // Get the current date
  var currentDate = new Date();

  // Set the target date to March 1 of the current year
  var targetDate = new Date(currentDate.getFullYear(), month, 1); // Note: Months are 0-indexed, so March is represented by 2
  // Calculate the difference in days
  var timeDifference = targetDate.getTime() - currentDate.getTime();
  var daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
  var poolStartDate = new Date(currentDate.getFullYear(), month - 3, 1);

  // days difference from now and previous day of 1
  return {
    days: (daysDifference - 1) < 0 ? 0 : daysDifference - 1,
    dateFormat: new Date(targetDate.setDate(targetDate.getDate() - 1)).toISOString(),
    startDate: new Date(new Date().setHours(24, 0, 0, 0)).toISOString(),
    poolStartDate: poolStartDate.toISOString()
  }
}

export const LSsetItem = (key, val) => localSet(key,val);
export const LSgetItem = (key) => localGet(key)

export const adminList = ["Super admin", "Admin", "Report only", "KYT/KYC"];


export const getUtcTime = () => {
  // Create a new Date object.
  const now = new Date();

  // Get the UTC components directly.
  const utcDate = new Date(Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate(),
    now.getUTCHours(),
    now.getUTCMinutes(),
    now.getUTCSeconds()
  ));
  // Print the UTC time.
}
getUtcTime()



export const generateSeasonOptions = (startYear, endYear) => {
  const options = [];
  for (let year = startYear; year <= endYear; year++) {
    options.push({ label: `${year}`, value: `${year}` });
  }
  return options;
};

// export const localSet = (key, val) => localStorage.setItem(key, EncryptData({ data: val }));

// export const localGet = (key) => Decryptdata(localStorage.getItem(key))?.data 

export const localSet = (key, val) => localStorage.setItem(key,val);

export const localGet = (key) => localStorage.getItem(key);

